export const environment = {
  apiURL: 'https://afschat.demo.xeniosblockchaingroup.com',

  appVersion: require('../../package.json').version,
  background: 'afs-background.png',
  logo: 'afs-logo.png',
  name: 'Afs',
  production: false,
  sentryDSN: '',
  sentryEnvironment: '',
};
